import { useEffect, useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getAccessToken } from 'src/app/store/auth'

const AuthenRouterGuard = () => {
  const accessToken = useSelector(getAccessToken)

  return accessToken ? <Outlet /> : <Navigate to='/login' replace />
}

export default AuthenRouterGuard
